import React from "react";
import downloadIcon from "../assets/res/download.svg";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { GET_BASE_URL } from "../utils/Constants";
import startIcon from "../assets/res/star_icon.svg"

function AppCard({ app, onGameClicked }) {
  return (
    <div
      onClick={onGameClicked}
      className="flex cursor-pointer items-center rounded-xl border border-gray-100 bg-white p-2 mx-4 shadow-sm transition hover:shadow-md active:scale-[0.99]"
    >
      <div className="flex flex-row min-w-0 flex-grow">
        <div className="w-[64px] h-[64px] bg-gray-300 rounded-xl mr-4 flex-shrink-0">
          <LazyLoadImage
            src={GET_BASE_URL() + "images/" + app.image}
            className="w-[64px] h-[64px] bg-gray-300 rounded-xl mr-4"
          />
        </div>
        <div className="flex-grow min-w-0">
          <h2 className="text-lg medium text-m line-clamp-1">{app.name}</h2>

          <div className="flex flex-row items-center">
            <div className="text-gray-900 medium text-sm flex items-center">
              <LazyLoadImage
                src={startIcon}
                className="w-[18px] h-[18px] flex-shrink-0"
              />
              <div>{app.rating}</div>
            </div>
            {app.category === "Mod" &&
              <div className="medium text-[11px] uppercase tracking-wide rounded-md bg-gray-100 text-gray-600 px-2 py-[1px] ml-2">
                {app.category}
              </div>
            }
            {app.category === "Game" &&
              <div className="medium text-[11px] uppercase tracking-wide rounded-md bg-primary/10 text-primary px-2 py-[1px] ml-2">
                {app.category}
              </div>
            }
            {app.category === "App" &&
              <div className="medium text-[11px] uppercase tracking-wide rounded-md border border-gray-300 text-gray-600 px-2 py-[1px] ml-2">
                {app.category}
              </div>
            }

          </div>

          <p className=" medium text-sm text-primary">
            {app.isForIos && "iOS "} {app.isForIos && app.isForAndroid && "/"}{" "}
            {app.isForAndroid && "Android"}
          </p>
        </div>
      </div>

      <button
        className="ml-auto flex h-[40px] w-[40px] flex-shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-primary to-primaryDark text-white shadow-sm transition active:scale-90"
        onClick={(e) => {
          e.stopPropagation();
          onGameClicked();
        }}
      >
        <img src={downloadIcon} className="h-[20px] w-[20px]" />
      </button>
    </div>
  );
}

export default AppCard;
